import { TbCalendarEventFilled, TbDeviceCctvFilled, TbFileTextFilled, TbPhoneFilled, TbSettingsFilled, TbShieldCheckFilled, TbUserFilled } from "react-icons/tb";
// src/modules/AppWrapper2/types.ts
var WebAppIds = /* @__PURE__ */ function(WebAppIds) {
	WebAppIds["Admin"] = "admin";
	WebAppIds["Dispatch"] = "dispatch";
	WebAppIds["IntegrationSentinel"] = "integration-sentinel";
	WebAppIds["Ops"] = "ops";
	WebAppIds["Portal"] = "portal";
	WebAppIds["Profile"] = "profile";
	WebAppIds["Scheduling"] = "scheduling";
	return WebAppIds;
}({});
/**
* Source of truth for the side panel's tabs. Kept as a runtime array (not just a
* type) so persisted values read back from localStorage can be validated against
* it — a stale id from a removed tab must not be restored.
*/
var SIDE_PANEL_CONTENTS = [
	"mail",
	"notifications",
	"organization",
	"systemInfo",
	"user"
];
var WEB_APPS_LIST = [
	{
		color: "oklch(0.60 0.07 250)",
		description: "Dispatch Console",
		icon: TbPhoneFilled,
		iconColor: "oklch(0.24 0.05 250)",
		id: "dispatch",
		link: "/dispatch",
		name: "Dispatch"
	},
	{
		color: "oklch(0.60 0.07 285)",
		description: "Manage Sentinel Integration with THERMS",
		icon: TbDeviceCctvFilled,
		iconColor: "oklch(0.24 0.05 285)",
		id: "integration-sentinel",
		link: "/sentinel",
		name: "Sentinel"
	},
	{
		color: "oklch(0.60 0.07 210)",
		description: "Operations information, reporting & tracking",
		icon: TbShieldCheckFilled,
		iconColor: "oklch(0.24 0.05 210)",
		id: "ops",
		link: "/ops",
		name: "OPS"
	},
	{
		color: "oklch(0.60 0.10 27)",
		description: "Manage Organization settings, Users, Locations, etc.",
		icon: TbSettingsFilled,
		iconColor: "oklch(0.24 0.06 27)",
		id: "admin",
		link: "/admin",
		name: "Admin"
	},
	{
		color: "oklch(0.60 0.07 155)",
		description: "View events, info, logs & reports for Locations",
		icon: TbFileTextFilled,
		iconColor: "oklch(0.24 0.05 155)",
		id: "portal",
		link: "/portal",
		name: "Portal"
	},
	{
		description: "Manage Personal Information and Settings",
		icon: TbUserFilled,
		id: "profile",
		link: "/profile",
		name: "Profile"
	},
	{
		color: "oklch(0.62 0.075 75)",
		description: "View, build & manage the Schedule & Time Logs",
		icon: TbCalendarEventFilled,
		iconColor: "oklch(0.26 0.05 75)",
		id: "scheduling",
		link: "/scheduling",
		name: "Scheduling"
	}
];
var WEB_APPS_LIST_BY_NAME = {
	ADMIN: WEB_APPS_LIST.find((a) => a.id === "admin"),
	DISPATCH: WEB_APPS_LIST.find((a) => a.id === "dispatch"),
	INTEGRATION_SENTINEL: WEB_APPS_LIST.find((a) => a.id === "integration-sentinel"),
	OPS: WEB_APPS_LIST.find((a) => a.id === "ops"),
	PORTAL: WEB_APPS_LIST.find((a) => a.id === "portal"),
	PROFILE: WEB_APPS_LIST.find((a) => a.id === "profile"),
	SCHEDULING: WEB_APPS_LIST.find((a) => a.id === "scheduling")
};
var WEB_APPS_BY_ID = Object.fromEntries(WEB_APPS_LIST.map((app) => [app.id, app]));
export { SIDE_PANEL_CONTENTS, WEB_APPS_BY_ID, WEB_APPS_LIST, WEB_APPS_LIST_BY_NAME, WebAppIds };

//# sourceMappingURL=types.js.map